export default {

  // api_url(_, _2, _3, rootGetters) {
  //   return rootGetters.api_url;
  // },
};